import { createContext, useContext } from 'react';
import { EngagementSubmissionData } from '@/generated/graphql';
import { ActionType } from './actions';
import { FullSubmissionFragment } from '@/generated/graphql';
export type AdminSubmissionContextType<T extends EngagementSubmissionData> = {
  dispatch: React.Dispatch<ActionType<T>>;
  state: T;
  submission: FullSubmissionFragment & { data: T };
};

export const AdminSubmissionContext = createContext<
  AdminSubmissionContextType<any> | undefined
>(undefined);

export function useAdminSubmissionContext<
  T extends EngagementSubmissionData,
>() {
  const ctx = useContext(AdminSubmissionContext);
  if (!ctx)
    throw new Error(
      'useAdminSubmissionContext must be used within an AdminSubmissionProvider',
    );
  return ctx as AdminSubmissionContextType<T>;
}
